import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Auth from '../../lib/users/auth';

import CompaniesApi from '../../lib/companies/companies-api';

import Card from '../../components/grants/card';
import { ViewButton, ManageButton } from '../../components/buttons';


import UpcomingGrants from '../grants-applications/components/grants-upcoming';

import {Layout, SeventyThirtyLayout} from '../../layouts';
import {stringToFriendlyDatetime} from "../../lib/helpers/datetime-helpers";
import activityParams from "../../lib/users/activity";




function Welcome() {
    return (
        <div className="website-topbar__welcome">
            <p>Welcome to</p>
            <h3>myEB</h3>
        </div>
    )
}

function DashboardCard() {
    return (
        <div className='grants-list dashboard-cards'>
            <p className="section__title">Where would you like to start?</p>

            <div className="grants-list__content">
                <div className="grants-list__inner">
                    <Card
                        title={'Grants'}
                        buttons={<>
                            <ViewButton onClick={() => window.location.href="/myeb/grants"} responsive={false}/>
                            <ManageButton onClick={() => window.location.href="/myeb/grants/applications"} responsive={false}>Applications</ManageButton>
                            </>}/>
                    <Card
                        title={'My Account'}
                        buttons={<>
                            <ViewButton onClick={() => window.location.href="/myeb/account"} responsive={false} />
                            </>}/>
                </div>
            </div>
        </div>
    )
}


class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            history: [

            ]
        };
    }

    componentDidMount() {
        this.getUserActivity();
    }



    getUserActivity() {
        CompaniesApi.getUserActions(Auth.user.company_id).then(data => {

            this.setState({history : data.map(item => {
                    return activityParams(item);
                })})
        });
    }


    render() {
        return (
            <Layout topLeft={<Welcome/>}>
                <SeventyThirtyLayout main={<DashboardCard/>} sectionOne={{
                    title: 'Latest Activity', component: <UpcomingGrants
                    title={'Latest Activity'}
                    items={this.state.history.map(item => {
                        return {
                            description: item.message,
                            id: item.body,
                            meta: `By ${item.created_by}, ${item.created_at},`,
                            link: item.link,
                        }
                    })}/>
                }}/>
            </Layout>
        );
    }

}

const el = document.getElementById('dashboard');

if (el) {
    ReactDOM.render(<Dashboard/>, el);
}
